import { WidgetProps } from "@rjsf/utils";
import { useContext, useEffect } from "react";
import { useLazyMallServiceListMallsQuery } from "../../../../../app/genericApiGenerated";
import CustomisedSelectWidget from "./CustomisedSelectWidget";

const MallsSelectWidget = (props: WidgetProps) => {
  const value = props.value;
  const [mallsTrigger, mallsResult] = useLazyMallServiceListMallsQuery({});

  const malls = mallsResult.currentData?.malls;

  const items = malls
    ?.filter((user) => typeof user.name !== "undefined")
    .map((e, index) => {
      return {
        id: index.toString(),
        label: e.display_name ?? "",
        value: e.name ?? "0",
      };
    });

  useEffect(() => {
    mallsTrigger({});
  }, []);
  return CustomisedSelectWidget(props, {
    items: items || [],
    itemsLoading: mallsResult.isLoading || mallsResult.isFetching,
    triggerMoreItems: () => mallsTrigger({}),
    value: value,
    selectTitle: "mall",
  });

  //   return SelectWidget(props, {
  //     items: items || [],
  //     itemsLoading: mallsResult.isLoading || mallsResult.isFetching,
  //     triggerMoreItems: () => mallsTrigger({}),
  //     value: value
  //   });
};

export default MallsSelectWidget;
